export default "__VITE_PUBLIC_ASSET__2138a41a__"